import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { AppUserModel } from 'src/app/admin-panel/models/members/app-user.model';
import { AppUserService } from 'src/app/admin-panel/services/members/app-user.service';

@Component({
  selector: 'app-details-app-user',
  templateUrl: './details-app-user.component.html',
  styleUrls: ['./details-app-user.component.scss']
})
export class DetailsAppUserComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public userId: string;
  public spinner: boolean = false;
  public appUserModel : AppUserModel = new AppUserModel();
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
  //#endregion
  //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public appUserService: AppUserService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.userId = this.config.data.id
      this.getsubscriberbyId(this.userId)
    }
  }

  ngOnInit(): void {
  }
  //#endregion
  //#region Public Methods
  getsubscriberbyId(id: string) {
    this.spinner = true;
    this.appUserService.getsubscriberbyId(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;         
          this.appUserModel = response;
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }
  cancel(){

  }
  //#endregion
}
